const AudioRecordingWorklet = `
class AudioProcessingWorklet extends AudioWorkletProcessor {
  buffer = new Int16Array(2048);
  index = 0;

  process(inputs) {
    if (!inputs[0]?.length) return true;
    
    const input = inputs[0][0];
    
    for (let i = 0; i < input.length; i++) {
      // Direct conversion to 16-bit PCM
      this.buffer[this.index++] = Math.max(-32768, 
        Math.min(32767, Math.floor(input[i] * 32767)));

      if (this.index >= this.buffer.length) {
        this.port.postMessage({
          event: "chunk",
          data: {
            int16arrayBuffer: this.buffer.buffer.slice()
          }
        });
        this.index = 0;
        this.buffer = new Int16Array(2048);
      }
    }
    return true;
  }
}

registerProcessor('audio-recorder-worklet', AudioProcessingWorklet);
`;

export default AudioRecordingWorklet;
